// import React, { useEffect, useRef } from "react";

// const ColumnVisibilitySidebar = ({ columns = [], onToggle, onClose }) => {
//   const sidebarRef = useRef(null);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         onClose();
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     document.body.style.overflow = "hidden"; 

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.body.style.overflow = "auto";
//     };
//   }, [onClose]);

//   if (!columns.length) return null;

//   return (
//     <div
//       ref={sidebarRef}
//       className="column-sidebar"
//       style={{
//         position: "fixed",
//         top: 0,
//         right: 0,
//         width: 280,
//         height: "100vh",
//         backgroundColor: "#fff",
//         boxShadow: "-3px 0 8px rgba(0,0,0,0.1)",
//         padding: 20,
//         zIndex: 2000,
//         overflowY: "auto",
//         transition: "transform 0.3s ease-in-out",
//       }}
//     >      <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 15,
//         }}
//       >
//         <h5 style={{ margin: 0, fontWeight: 600, fontSize: "1rem" }}>
//           Hide / Show Columns
//         </h5>
//         <i
//           className="fa-solid fa-xmark close-icon"
//           onClick={onClose}
//           role="button"
//           aria-label="Close sidebar"
//           style={{
//             fontSize: "20px",
//             color: "#444",
//             cursor: "pointer",
//             transition: "all 0.25s ease",
//           }}
//           onMouseEnter={(e) =>
//             (e.target.style.transform = "rotate(90deg) scale(1.2)")
//           }
//           onMouseLeave={(e) =>
//             (e.target.style.transform = "rotate(0deg) scale(1)")
//           }
//         ></i>
//       </div>
//       <hr />
//       <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
//         {columns.map((col) => (
//           <div
//             key={col.key}
//             className="form-check mb-2"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//               padding: "3px 0",
//             }}
//           >
//             <input
//               type="checkbox"
              
//               id={col.key}
//               checked={col.visible}
//               onChange={() => onToggle(col.key)}

//             />
//             <label
//               htmlFor={col.key}
//               style={{
//                 cursor: "pointer",
//                 userSelect: "none",
//                 fontSize: "0.95rem",
//                 fontWeight: 500,
//               }}
//             >
//               {col.label}
//             </label>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ColumnVisibilitySidebar;

import React, { useEffect, useRef } from "react";
import "./styles/ColumnSidebar.css";

const ColumnVisibilitySidebar = ({ columns = [], onToggle, onClose }) => {
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  if (!columns.length) return null;

  return (
    <>

      <div ref={sidebarRef} className="cv-sidebar">
        <div className="cv-header">
          <h5>Manage Columns</h5>
          <i
            className="fa-solid fa-xmark cv-close"
            onClick={onClose}
          ></i>
        </div>

        <div className="cv-content">
          {columns.map((col) => (
            <label key={col.key} className="cv-item">
              <input
                type="checkbox"
                checked={col.visible}
                onChange={() => onToggle(col.key)}
              />
              <span className="cv-checkmark"></span>
              <span className="cv-label">{col.label}</span>
            </label>
          ))}
        </div>
      </div>
    </>
  );
};

export default ColumnVisibilitySidebar;
